import { render } from "./materialView.vue?vue&type=template&id=0f2e273a"
import script from "./materialView.vue?vue&type=script&lang=js"
export * from "./materialView.vue?vue&type=script&lang=js"

import "./materialView.vue?vue&type=style&index=0&id=0f2e273a&lang=css"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__